<div *ngIf="isLoading" class="spinner-overlay">
    <div class="spinner">
        <mat-spinner></mat-spinner>
    </div>
</div>

<body>
    <div class="headerContratos">
        <div class="align-left search">
            <input type="text" [(ngModel)]="searchString" (keyup)="aplicarFiltro()" placeholder="filtrar palavras">

            <!-- <label for="startDate">Data Inicial:</label> -->
            <input #dateInput type="date" class="dateInput" id="startDate" [(ngModel)]="startDateFilter">

            <!-- <label for="endDate">Data Final:</label> -->
            <input #dateInput2 type="date" class="dateInput" id="endDate" [(ngModel)]="endDateFilter">

            <button class="inputDate" (click)="applyFilter()">Filtrar</button>
            <button class="inputDate" (click)="clearFilter()">Limpar filtro</button>

        </div>

        <h3 class="subtitulo" style="font-family: 'Times New Roman', Times, serif;">Relatório Interplantas</h3>
        <div class="align-right">
            <!-- <button class="btn-frete" mat-button (click)=" editDialog(items)">
        <span class="material-icons">note_add</span> Solicitar Frete Extra
      </button>
      <button class="btn-frete" mat-button (click)="exportToExcel(items)">
        <span class="material-icons">print</span> Print
      </button> -->
            <div class="icone-setting">
                <div class="icone-setting">
                    <!-- <i-feather name="file-plus"></i-feather> -->
                    <button class="btn-frete icone-setting" mat-button (click)="solicitarFrete()"><i-feather
                            name="file-plus"></i-feather>Inserir Registro</button>
                </div>
                <div class="icone-setting">
                    <!-- <i-feather name="printer"></i-feather> -->
                    <!-- <button class="btn-frete icone-setting" mat-button (click)="exportToExcel(items)"><i-feather
                            name="printer"></i-feather>Print</button> -->
                    <button class="btn-frete icone-setting" mat-button (click)="exportToExcel(allItems)"><i-feather
                            name="printer"></i-feather>Print All Items</button>
                </div>
            </div>
        </div>
    </div>
    <ul>
        <table id="excel-table">
            <thead>
                <tr class="header-row">
                    <td><label>ID</label></td>
                    <td><label>Date</label></td>
                    <td><label>Planned Arrival Date</label></td>
                    <td><label>Planned Arrival Time</label></td>
                    <td><label>Trip ident</label></td>
                    <td><label>Linha</label></td>
                    <td><label>Carrier</label></td>
                    <td><label>Vehicle</label></td>
                    <td><label>Plate</label></td>
                    <td><label>Motorista</label></td>
                    <td><label>Path</label></td>
                    <td><label>Weight (ton)</label></td>
                    <td><label>Distance (km)</label></td>
                    <td><label>Consumo</label></td>
                    <td><label>Emissao</label></td>
                    <td><label>Emissão Total</label></td>
                    <!--<td><label>CO2e/Kg (KPI)</label></td> -->
                    <td><label>Nota Fiscal</label></td>
                    <td><label>CTE Sesé</label></td>
                    <td><label>Valor Frete</label></td>
                    <td><label>Fornecedor</label></td>
                    <td><label>Ações</label></td>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let item of allItems">
                    <td>{{ item.ID }}</td>
                    <td>{{ item.date | date:'dd-MM-yy'}}</td>
                    <td>{{ item.plannedArrival | date:'dd-MM-yy' }}</td>
                    <td>{{ item.timeplannedArrival }}</td>
                    <!-- <td>{{ (item.locationPickup == "other" ? item.otherLocationPickup : item.locationPickup) +
                        (item.areaPickup ?
                        " - " + item.areaPickup : "")}}</td>
                    <td>{{ item.addressPickup + (item.cityPickup ? " - " + item.cityPickup : "") + (item.statePickup ? "
                        - " +
                        item.statePickup : "")}}</td>
                    <td>{{ (item.locationDelivery == "other" ? item.otherLocationDelivery : item.locationDelivery) +
                        (item.areaDelivery ? " - " + item.areaDelivery : "")}}</td>
                    <td>{{ item.addressDelivery + (item.cityDelivery ? " - " + item.cityDelivery : "") +
                        (item.stateDelivery ? " -
                        " + item.stateDelivery : "") }}</td>
                    <td>{{ item.dateDelivery | date:'dd-MM-yy' + " " + item.timeDelivery }}</td> -->
                    <td>{{ item.tripIdent }}</td>
                    <td>{{ item.linha}}</td>
                    <td>{{ item.carrier}}</td>
                    <td>{{ item.vehicle ? item.vehicle : item['Transport Type']}}</td>
                    <td>{{ item.plate ? item.plate : item.Plate}}</td>
                    <td>{{ item.motorista}}</td>
                    <td>{{ item.path}}</td>
                    <td>{{ item.weight ? item.weight : item['Weight Loaded']}}</td>
                    <td>{{ item.distance ? item.distance : item['Total Distance']}}</td>
                    <td>{{ item.consumo}}</td>
                    <td>{{ item.emissao}}</td>
                    <td>{{ item.emissaoTotal | number:'1.2-2'}}</td>
                    <!--<td>{{ item.COKPI | number:'1.2-2'}}</td> -->
                    <td>{{ item.notaFiscal}}</td>
                    <td>{{ item.CTESese}}</td>
                    <td>{{ item.valorFrete ? item.valorFrete : item['Total Cost']}}</td>
                    <td>{{ item.fornecedor ? item.fornecedor : item['Fornecedor 1']}}</td>
                    <td class="action-buttons">
                        <button [disabled]="!isCarrierEnabled && !isAdminEnabled" mat-icon-button color="primary"
                            aria-label="Editar" (click)="editDialog(item)">
                            <span class="material-icons">edit</span>
                        </button>
                        <button [disabled]="usuarioLogado.role != '9' && usuarioLogado.role != '2'" mat-icon-button
                            color="warn" aria-label="Excluir" (click)="deleteItem(item.ID, urlConsulta, query)">
                            <span class="material-icons">delete</span>
                        </button>
                        <!-- <button mat-icon-button color="warn" aria-label="Print" (click)="addImageToExcel(item)">
                            <span class="material-icons">print</span>
                        </button> -->
                    </td>
                </tr>
            </tbody>
        </table>
    </ul>
</body>
<clr-modal [(clrModalOpen)]="dialogOpen" [clrModalSize]="'md'" class="dialog-container">
    <!-- <div> -->

    <h3 class="modal-title">Cadastrar Registro</h3>
    <!-- <h3 class="modal-title" style="font-size: 15px;">Contact: <abbr
            style="color: #3b82f6; font-size: 15px;">SSBVAD</abbr>
        Phone: 55 11 4344-8947 | Mobile: +55 11
        97488-2943</h3> -->
    <!-- </div> -->
    <div class="modal-body scroll-container">
        <form class="inputs">
            <table class="table2000">
                <tr>
                    <td class="selectStatus">
                        <label class="modal-label">Planned Arrival</label>
                    </td>
                    <td class="selectStatus">
                        <input type="date" name="plannedArrival" [(ngModel)]="item.plannedArrival" class="modal-input1">
                    </td>
                    <td class="input-maior selectStatus">
                        <input type="time" name="timeplannedArrival" [(ngModel)]="item.timeplannedArrival"
                            class="modal-input1">
                    </td>
                    <td>
                        <label class="modal-label">Trip Ident</label>
                    </td>
                    <td>
                        <input type="text" name="tripIdent" [(ngModel)]="item.tripIdent" class="modal-input1">
                    </td>
                    <td class="selectStatus">
                        <label class="modal-label">Carrier</label>
                    </td>
                    <!-- <td>
                            <input type="text" name="carrier" [(ngModel)]="item.carrier" class="modal-input1">
                        </td> -->
                    <td>
                        <select id="carrier" name="carrier" [(ngModel)]="item.carrier" class="modal-select"
                            (ngModelChange)="onFieldChanged2('carrier', $event)">
                            <option value="-">-</option>
                            <option *ngFor="let carrier of typesCarriers" [value]="carrier">{{ carrier }}</option>
                        </select>
                    </td>
                </tr>
                <tr>
                    <!-- <td>
                        <label class="modal-label">Vehicle</label>
                    </td>
                    <td>
                        <input type="text" name="vehicle" [(ngModel)]="item.vehicle" class="modal-input1">
                    </td> -->
                    <td class="selectStatus">
                        <label class="modal-label">Vehicle</label>
                    </td>
                    <td>
                        <select id="vehicle" name="vehicle" [(ngModel)]="item.vehicle" class="modal-select"
                            (blur)="onFieldTouched()" (ngModelChange)="onFieldChanged2('vehicle', $event)">
                            <option value="-">-</option>
                            <option *ngFor="let vehicle of typesVehicles" [value]="vehicle.modelo">{{ vehicle.modelo }}
                            </option>
                        </select>
                        <!-- <div *ngIf="campoTocado && (item.vehicle == null || item.vehicle == undefined || item.vehicle == '')">
                        <small class="text-danger">Required</small>
                    </div> -->
                    </td>
                    <td class="selectStatus">
                        <label class="modal-label">Plate</label>
                    </td>
                    <!-- <td class="align-left input-maior"> -->
                    <td>
                        <input type="text" name="plate" [(ngModel)]="item.plate" class="modal-input0">
                    </td>
                    <td class="selectStatus">
                        <label class="modal-label">Motorista</label>
                    </td>
                    <td>
                        <input type="text" name="motorista" [(ngModel)]="item.motorista" class="modal-input1">
                    </td>
                </tr>
                <tr>
                    <td class="selectStatus">
                        <label class="modal-label">Linha</label>
                    </td>
                    <td>
                        <input type="text" name="linha" [(ngModel)]="item.linha" class="modal-input1">
                    </td>

                    <td class="selectStatus">
                        <label class="modal-label">Path</label>
                    </td>
                    <td>
                        <input type="text" name="path" [(ngModel)]="item.path" class="modal-input1">
                    </td>
                    <td class="selectStatus">
                        <label class="modal-label">Weight</label>
                    </td>
                    <td>
                        <input type="text" name="weight" [(ngModel)]="item.weight" class="modal-input1">
                    </td>
</tr>
<tr>
                    <td class="selectStatus">
                        <label class="modal-label">Distance</label>
                    </td>
                    <td>
                        <input type="text" name="distance" [(ngModel)]="item.distance" class="modal-input1">
                    </td>
                    <!-- <td class="selectStatus">
                        <label class="modal-label">CO2e</label>
                    </td>
                    <td>
                        <input type="text" name="CO2e" [(ngModel)]="item.CO2e" class="modal-input1">
                    </td>
                    <td class="selectStatus">
                        <label class="modal-label">CO2eKPI</label>
                    </td>
                    <td>
                        <input type="text" name="COKPI" [(ngModel)]="item.COKPI" class="modal-input1">
                    </td> -->
<!-- 
                </tr>
                <tr> -->
                    <td>
                        <label class="modal-label">Nota Fiscal</label>
                    </td>
                    <td>
                        <input type="text" name="notaFiscal" [(ngModel)]="item.notaFiscal" class="modal-input1">
                    </td>
                    <td>
                        <label class="modal-label">CTESese</label>
                    </td>
                    <td>
                        <input type="text" name="CTESese" [(ngModel)]="item.CTESese" class="modal-input1">
                    </td>
                    <td>
                        <label class="modal-label">Valor Frete</label>
                    </td>
                    <td>
                        <input type="text" name="valorFrete" [(ngModel)]="item.valorFrete" class="modal-input1">
                    </td>
</tr>
<tr>
                    <td class="selectStatus">
                        <label class="modal-label">Fornecedor</label>
                    </td>
                    <td class="selectStatus">
                        <select class="selectVehicle" name="fornecedor" [(ngModel)]="item.fornecedor" appendTo="body"
                            (blur)="onFieldTouched()"
                            (ngModelChange)="onFieldChanged('fornecedor', $event); verificaContato( $event)">
                            <option *ngFor="let type of this.placesOrigin" [value]="type">{{ type }}</option>
                            <option value="other">Other</option>
                        </select>
                        <!-- <div
        *ngIf="campoTocado && (item.locationPickup == null || item.locationPickup == undefined || item.locationPickup == '')">
        <small class="text-danger">Required</small>
    </div> -->
                    </td>
                </tr>
            </table>
            <div class="modal-div">
                <button class="modal-button" type="button" (click)="salvar(item)">Save</button>
                <button class="modal-button" type="button" (click)="cancel()">Cancel</button>
            </div>
        </form>
    </div>
</clr-modal>

<div *ngIf="isLoading" class="spinner-overlay">
    <div class="spinner">
        <mat-spinner></mat-spinner>
    </div>
</div>